/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import Text from './Text';

export default function SemiTitle({ children, ...rest }) {
  if (!children) return null;
  return (
    <Text variant="semiTitle" sx={{ marginTop: 3, marginBottom: 2 }} {...rest}>
      {children}
    </Text>
  );
}
